import { render, staticRenderFns } from "./FamilySalesReport.vue?vue&type=template&id=58de684c&"
import script from "./FamilySalesReport.vue?vue&type=script&lang=js&"
export * from "./FamilySalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports